var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFileIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_3098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9491 5.53651L16.4651 2.05051C15.8164 1.39865 15.045 0.881842 14.1953 0.529971C13.3457 0.178099 12.4347 -0.0018556 11.5151 0.00051133H7.00012C5.67453 0.00209919 4.40368 0.529393 3.46634 1.46673C2.529 2.40407 2.00171 3.67492 2.00012 5.00051V19.0005C2.00171 20.3261 2.529 21.597 3.46634 22.5343C4.40368 23.4716 5.67453 23.9989 7.00012 24.0005H17.0001C18.3257 23.9989 19.5966 23.4716 20.5339 22.5343C21.4712 21.597 21.9985 20.3261 22.0001 19.0005V10.4855C22.0026 9.56593 21.8226 8.655 21.4705 7.80549C21.1185 6.95597 20.6014 6.18475 19.9491 5.53651ZM18.5351 6.95051C18.8405 7.26466 19.1031 7.6177 19.3161 8.00051H15.0001C14.7349 8.00051 14.4806 7.89515 14.293 7.70762C14.1055 7.52008 14.0001 7.26573 14.0001 7.00051V2.68451C14.3831 2.89744 14.7364 3.15967 15.0511 3.46451L18.5351 6.95051ZM20.0001 19.0005C20.0001 19.7962 19.6841 20.5592 19.1214 21.1218C18.5588 21.6844 17.7958 22.0005 17.0001 22.0005H7.00012C6.20447 22.0005 5.44141 21.6844 4.8788 21.1218C4.31619 20.5592 4.00012 19.7962 4.00012 19.0005V5.00051C4.00012 4.20486 4.31619 3.4418 4.8788 2.87919C5.44141 2.31658 6.20447 2.00051 7.00012 2.00051H11.5151C11.6791 2.00051 11.8381 2.03251 12.0001 2.04751V7.00051C12.0001 7.79616 12.3162 8.55922 12.8788 9.12183C13.4414 9.68444 14.2045 10.0005 15.0001 10.0005H19.9531C19.9681 10.1625 20.0001 10.3205 20.0001 10.4855V19.0005Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_3098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFileIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/file_icon.037b527c55893b040037aa67dc33e056.svg";